<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          :color="color"
          class="mr-4"
          v-bind="attrs"
          v-on="on"
          type="submit"
          :disabled="disabled"
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "SubmitButtonComponent",
  props: {
    text: {
      type: String,
      default: "Buscar",
    },
    icon: {
      type: String,
      default: "mdi-magnify",
    },
    color: {
      type: String,
      default: "primary",
    },
    disabled: {
      type: Boolean,
      default: false
    },
  }
}
</script>